import React, { useEffect } from 'react';
import VasNormalDetail from './component/VasNormalDetail';
import VASInboundCom from '@/pages/VASOrderDetail/component/VASInboundCom';
import VASInsideCom from '@/pages/VASOrderDetail/component/VASInsideCom';
import VASCargoCom from '@/pages/VASOrderDetail/component/VASCargoCom';
import { getSearchParams, useParams } from 'ice';

import { getTableList } from './component/index.services';
import { RootStates } from './component/index.interface';
import { useSetState } from 'ahooks';

const VASOrderDetail = () => {
  const { tid } = useParams<{ tid: string }>();
  const { sortType } = getSearchParams();

  const [states, setStates] = useSetState<RootStates>({
    allDatas: {
      valueAddedTaskDTO: {},
      valueAddedTaskSkuDTOList: [],
      valueAddedTaskPackageDTOList: [],
      valueAddedTaskOperationDetailDTOList: [],
    },
    type: '',
  });

  const getAllData = () => {
    return new Promise((resolve, reject) => {
      getTableList({ consignmentNo: tid, sortType })
        .then((res) => {
          let type;
          const serviceTypeList = ['RP', 'PG', 'HL', 'CS', 'VG', 'VVW', 'UP', 'BP', 'SS', 'OTOC'];
          if (serviceTypeList.includes(res?.valueAddedTaskDTO?.serviceType)) type = 'normal';
          else if (res?.valueAddedTaskDTO?.serviceType === 'TOC') type = 'cargo'; // 货权转移 TOC
          // else if (res?.valueAddedTaskDTO?.serviceType === 'MFC') type = 'inbound'; // MF组合增值服务 MFC
          // // else type = 'inside'; // 一对一换标 OTOC
          else if (res?.valueAddedTaskDTO?.inboundOrder) type = 'inbound'; // 入库段 MF组合增值服务
          else type = 'inside'; // 库内段
          console.log('vas type:', type);

          setStates({
            allDatas: res,
            type,
          });
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <>
      {states.type === 'normal' && (
        <VasNormalDetail consignmentNo={tid} allDatas={states.allDatas} callback={() => getAllData()} />
      )}
      {states.type === 'inbound' && (
        <VASInboundCom consignmentNo={tid} allDatas={states.allDatas} callback={() => getAllData()} />
      )}
      {states.type === 'inside' && (
        <VASInsideCom consignmentNo={tid} allDatas={states.allDatas} callback={() => getAllData()} />
      )}
      {states.type === 'cargo' && (
        <VASCargoCom consignmentNo={tid} allDatas={states.allDatas} callback={() => getAllData()} />
      )}
    </>
  );
};

export default VASOrderDetail;
